import { render } from "./FooterUlb.vue?vue&type=template&id=2949e3bc&scoped=true"
import script from "./FooterUlb.vue?vue&type=script&lang=js"
export * from "./FooterUlb.vue?vue&type=script&lang=js"

import "./FooterUlb.vue?vue&type=style&index=0&id=2949e3bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2949e3bc"]])

export default __exports__